import React from 'react'
import ActionTextButton from '../Templates/ActionTextButton'

const InactiveTextButton = ({onClick}) => {
  return (
    <ActionTextButton
      className="s-color-red red"
      onClick={onClick}
      icon="trash"
      text="Inactivar"
    />
  )
}

export default InactiveTextButton
